const textHighlight = {
  load() {
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach((el) => {
        if (!el.textContent.includes("{")) return;
        el.innerHTML = el.innerHTML.replace(
          /\{([^}]+)\}/g,
          '<span class="TextHighlight"><span>$1</span></span>',
        );
      });

      document.querySelectorAll(".main-breadcrumbs a, .main-breadcrumbs .breadcrumb_last").forEach((el) => {
        if (!el.textContent.includes("{")) return;
        el.textContent = el.textContent.replace(/\{([^}]+)\}/g, "$1");
      });

      document.querySelectorAll("#primary-navigation a").forEach((el) => {
        if (!el.textContent.includes("{")) return;
        el.textContent = el.textContent.replace(/\{([^}]+)\}/g, "$1");
      });
    });
  },
};

export default textHighlight;
